import React, { useContext } from 'react';
import { ListItem, ListItemButton, ListItemContent, ListItemDecorator } from '@mui/joy';
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import { Link, useLocation } from 'react-router';
import { LayoutContext } from '../context';
import { accountHasPermission, positionsOf } from '../roles';
import { closeSidebar } from '../utils';

export default function SettingsNavItems() {
  const { account, setSidebarOpen } = useContext(LayoutContext);
  const { pathname } = useLocation();
  return <>{[
    ['/access', 'Доступы', 'access.manage', AdminPanelSettingsRoundedIcon],
    ['/settings', 'Настройки', 'settings.chats.view', SettingsRoundedIcon],
    ['/documents/settings', 'Документы и ЭДО', null, DescriptionRoundedIcon],
  ].filter(([, , permission]) => permission ? accountHasPermission(account, permission) : account?.role === 'administrator' || positionsOf(account).includes('head_manager')).map(([path, label, , Icon]) => {
    const active = pathname === path || pathname.startsWith(`${path}/`);
    return <ListItem key={path} sx={{ width: '100%' }}>
      <ListItemButton component={Link} to={path} variant="soft" color={active ? 'primary' : 'neutral'}
        aria-current={active ? 'page' : undefined}
        sx={{ lineHeight: 1.1, px: 2, borderRadius: 'lg' }}
        onClick={() => { closeSidebar(); setSidebarOpen(false); }}>
        <ListItemDecorator aria-hidden="true"><Icon /></ListItemDecorator>
        <ListItemContent title={label} sx={{ minWidth: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{label}</ListItemContent>
        <KeyboardArrowRightRoundedIcon aria-hidden="true" />
      </ListItemButton>
    </ListItem>;
  })}</>;
}
